<!--
 * @Author: Zj
 * @Date: 2022-01-10 14:12:27
 * @LastEditTime: 2024-05-28 17:52:48
 * @LastEditors: lmy
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gdp-cloud-app\src\views\medical-edu\detail\dph\index.vue
-->
<template>
  <div class="dph">
    <div class="contentPart">
      <div class="fixedDiv">
        <span class="status">{{detail.liveStatus}}</span>
        <div class="coverImg">
          <img :src='src' />
        </div>
        <div class="dphName">{{detail.dataName}}</div>
        <div class="series">
          <span class="name">{{detail.seriesName}}</span>
          <i>|</i>
          <span class="grade">{{detail.score}}分</span>
        </div>
        <div class="firstNav">
          <firstNav @getClickFirstnav="getClickFirstnav" :navData="firstNavData" :indexs="indexs"></firstNav>
        </div>
      </div>
      <div class="heightPerch" :style="{height:height}">
      </div>
      <div class="contentDiv">
        <div v-if='indexs===0'>
          <div class="courseDetail">
            <div class="titlePlane">
              <span class="title"></span>
              <span class="plane">
                课程简介
              </span>
            </div>
            <div class="introduceMain">
              <div class="itemMain">
                <div class="itemName">会议主持</div>
                <div class="item">{{detail.hostName}}</div>
              </div>
            </div>
            <div class="introduceMain">
              <div class="itemMain">
                <div class="itemName">会议地点</div>
                <div class="item">{{detail.meetingAddressShow}}</div>
              </div>
            </div>
            <div class="introduceMain">
              <div class="itemMain">
                <div class="itemName">课程时间</div>
                <div class="item">{{detail.startTime}}-{{detail.endLocalTime}}</div>
              </div>
            </div>
          </div>
          <div class="filePart">
            <div class="titlePlane">
              <span class="title"></span>
              <span class="plane">
                会议文件
              </span>
            </div>
            <div class="file" v-if="fileList.length!==0">
              <div class="fileList" v-for="(item,index) in fileList" :key="index">
                <img :src="item.imgsrc" alt="">
                <div class="fileName" @click="openFile(item)"> {{item.fileName}}</div>
              </div>
            </div>
            <div v-else>
              <nodata></nodata>
            </div>
          </div>
        </div>
        <div v-if='indexs===1'>
          <div class="caseLis" v-for='(item,index) in caseList' :key="index">
            <caselistCard :detail='item' @graphCase='graphCase'></caselistCard>
          </div>
        </div>
        <div v-if='indexs===2'>
          <attendList></attendList>
        </div>
      </div>
    </div>
    <div class="itemQuseqin" v-if='detail.examSwitch===1 && detail.liveStatus==="已结束"' @click="turnAnswer()">
      <img src="../../../../assets/btn_quiz@1x.png" />
      <span>答题</span>
    </div>
    <div class="enroll">
      <button v-if="detail.userApplyButtonStatus === 1 && detail.liveStatus !=='进行中'&&detail.liveStatus!=='已结束'" @click="apply()">报名参加</button>
      <button v-if="detail.liveStatus ==='进行中'" @click="enterMeeting()">进入会议室</button>
    </div>
  </div>
</template>
<script>
import firstNav from '../../../../components/basics/first-nav';
import caselistCard from '../../../../components/basics/case-list-card';
import nodata from '../../../../components/basics/no-data';
import attendList from '../../../../components/business/mdt-consult/c-mdt/attend-list';

export default {
  data () {
    return {
      indexs: 0,
      src: '',
      detail: {},
      firstNavData: [
        {
          text: '课程详情',
          status: 0
        },
        {
          text: '病例资料',
          status: 1
        },
        {
          text: '参会人员',
          status: 2
        }
      ],
      caseList: [],
      fileList: [],
      fileType: ['png', 'jpg', 'jpeg', 'gif', 'bmp'],
      // 会议室地点
      meettingUrl: '',
      height: ''
    };
  },
  created () {
    this.getDetail(this.$route.query.dataId);
    this.getCaseList(this.$route.query.dataId, this.$route.query.moduleId);
    this.getFileList(this.$route.query.dataId, this.$route.query.moduleId);
    if (localStorage.getItem('lastType') === JSON.stringify('caseCardList')) {
      this.indexs = 1;
    }
    setTimeout(() => {
      if (this.detail.dataName.length * 21 > window.innerWidth - 28) {
        this.height = '300px';
      } else {
        this.height = '270px';
      }
    }, 300);
  },
  methods: {
    getDetail (dataId) {
      this.$axios
        .post('edu/reading/get', {
          data: {
            id: dataId
          },
          version: this.$version
        })
        .then(res => {
          if (res.status) {
            this.detail = res.data;
            // @ts-ignore
            this.src = this.utils.mixedFileUrl(res.data.coverUrl);
            this.meettingUrl = res.data.meetingUrl;
          }
        });
    },
    // tab事件
    getClickFirstnav (e) {
      this.indexs = e;
    },
    // 获取病例
    getCaseList (dataId, moduleId) {
      this.$axios
        .post('edu/reading/case/list', {
          data: {
            readingId: dataId,
            moduleId: moduleId
          },
          version: this.$version
        })
        .then(res => {
          if (res.status) {
            res.data.forEach((element, index) => {
              element.index = index;
            });
            this.caseList = res.data;
          }
        });
    },
    // 获取文件列表
    getFileList (dataId, moduleId) {
      this.$axios
        .post('edu/file/list', {
          data: {
            dataId: dataId,
            moduleId: moduleId
          }
        })
        .then(res => {
          if (res.status) {
            res.data.forEach((item, index) => {
              // 获取文件类型
              item.file_type = item.fileName.split('.')[1];
              item.file_type = item.file_type.toLowerCase();
              if (item.file_type.indexOf('txt') !== -1) {
                item.status = 'txt';
              } else if (
                item.file_type.indexOf('docx') !== -1 ||
                item.file_type.indexOf('doc') !== -1
              ) {
                item.status = 'doc';
              } else if (
                item.file_type.indexOf('xlsx') !== -1 ||
                item.file_type.indexOf('xls') !== -1
              ) {
                item.status = 'excel';
              } else if (item.file_type.indexOf('ppt') !== -1) {
                item.status = 'ppt';
              } else if (item.file_type.indexOf('pdf') !== -1) {
                item.status = 'pdf';
              } else {
                item.status = 'img';
              }
              item.imgsrc = this.consultHandledata.handlefileTypeicon(
                item.status
              );
              this.fileList.push({
                fileId: item.fileId,
                fileName: item.fileName,
                imgsrc: item.imgsrc
              });
            });
          }
        });
    },
    openFile (item) {
      const ext = item.fileName.substring(item.fileName.lastIndexOf('.') + 1);
      if (this.fileType.includes(ext)) {
        // @ts-ignore
        window.open(this.utils.getFileUrl(item.fileId), '_blank');
      } else {
        this.downLoadFile(item.fileId);
      }
    },
    // 下载
    downLoadFile (fileId) {
      var a = document.createElement('a');
      a.style.display = 'none';
      // a.download = fileName;  //自定义名称
      // @ts-ignore
      a.href = this.baseUrl + 'file/download?fileId=' + Number(fileId);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 报名参加
    apply () {
      // @ts-ignore
      this.$axios
        .post('/edu/reading/user/apply ', {
          data: {
            id: this.$route.query.dataId
          },
          version: 0
        })
        .then(res => {
          this.getDetail(this.$route.query.dataId);
        });
    },
    // 在线答题
    turnAnswer () {
      this.$router.push({
        path: '/search/ques',
        query: {
          dataId: this.$route.query.dataId,
          moduleId: this.$route.query.moduleId
        }
      });
    },
    // 查看病例详情
    graphCase (caseDetail) {
      this.$router.push({
        path: '/edu_case',
        query: {
          type: 'caseCardList'
        }
      });
      localStorage.setItem('tempData', JSON.stringify(caseDetail));
    },
    // 进入会议室
    enterMeeting () {
      if (Number(this.$store.state.userInfo.platformId) === 78) {
        var url = '';
        url =
          'tango://join?enableGuestMode=true&welcomePage=false&portal=https://yiliao.lssvc.cn' +
          this.meetingUrl.split('yiliao.lssvc.cn')[1];
        window.open(url, '_blank');
      } else {
        window.open(this.meetingUrl, '_blank');
      }
    }
  },
  components: {
    firstNav,
    caselistCard,
    attendList,
    nodata
  }
};
</script>
<style lang='scss' scoped>
.dph {
  margin-top: 52px;
}
.status {
  display: inline-block;
  height: 32px;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  color: #ffffff;
  padding-top: 5px;
  font-size: 14px;
  text-align: center;
  position: fixed;
}
.fixedDiv {
  position: fixed;
  z-index: 2;
  width: 100%;
}
.contentDiv ::v-deep .imgPart img {
  margin: 0 auto;
}
.coverImg {
  width: 100%;
}
.coverImg img {
  width: 100%;
  height: 150px;
}
.firstNav ::v-deep .normalNav {
  box-shadow: none;
}
.caseLis {
  width: 49%;
  float: left;
  margin: 0px 1% 6px 0;
}
.contentDiv {
  overflow: hidden;
  padding: 0 13px;
  margin-top: 16px;
}
.dphName {
  font-family: PingFangSC-Semibold;
  font-size: 21px;
  color: #333333;
  letter-spacing: 0.27px;
  font-weight: 600;
  padding-bottom: 6px;
  background-color: $white;
  padding: 22px 14px 6px 14px;
  margin-top: -9px;
  border-radius: 10px 10px 0 0;
}
.series {
  font-size: 14px;
  color: #7d7d7d;
  letter-spacing: 0.18px;
  padding: 0 14px;
  background-color: $white;
}
i {
  padding: 0px 11px;
}
.title {
  width: 4px;
  height: 14px;
  background: #478ff8;
  border-radius: 2px;
  display: inline-block;
}
.plane {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.21px;
  font-weight: 600;
}
.itemName {
  float: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0.18px;
  font-weight: 400;
}
.item {
  text-align: right;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.18px;
  font-weight: 400;
}
.titlePlane {
  margin-bottom: 16px;
}
.itemMain {
  margin-bottom: 21px;
}

.fileList {
  img {
    width: 20px;
    display: inline-block;
    float: left;
    margin: 2px 10px 0 0;
  }
  .fileName {
    font-size: 14px;
    color: #7d7d7d;
    letter-spacing: 0;
    font-weight: 400;
    margin: 14px 0;
  }
}
.enroll {
  text-align: center;
  position: fixed;
  z-index: 43;
  bottom: 17px;
  width: 100%;
  button {
    background: #478ff8;
    border-radius: 22px;
    width: 80%;
    color: $white;
    height: 44px;
  }
}
.itemQuseqin {
  width: 48px;
  height: 48px;
  background-image: linear-gradient(90deg, #529eff 0%, #3d80ff 99%);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  position: fixed;
  z-index: 44;
  bottom: 64px;
  right: 10px;
  border-radius: 50%;
  text-align: center;
  img {
    display: block;
    margin: 0 auto;
    margin-top: 7px;
  }
  span {
    color: $white;
    font-size: 1px;
  }
}

.heightPerch {
  text-align: center;
}
</style>




